import React, { useRef, useState } from 'react'
import { AppPrimaryButton } from 'elements'
import { MASTER_ANSWERS_TABS } from './constants'
import { MasterListsTab } from './MasterListsTab'
import { MigrationWizardTab } from './MigrationWizardTab'
import { TemplateEditorTab } from './TemplateEditorTab'
import { PageHeaderRow, PageWrap, TabBar, TabContent } from './styles'

export const MasterAnswersPage = ({ companyId }) => {
    const [activeTab, setActiveTab] = useState('lists')
    const newListHandlerRef = useRef(null)

    return (
        <PageWrap>
            <PageHeaderRow>
                <h1>Master Answers</h1>
                {activeTab === 'lists' && (
                    <div className="header-actions">
                        <AppPrimaryButton
                            type="button"
                            onClick={() => newListHandlerRef.current?.()}
                        >
                            + New Master List
                        </AppPrimaryButton>
                    </div>
                )}
            </PageHeaderRow>

            <TabBar>
                {MASTER_ANSWERS_TABS.map(tab => (
                    <button
                        key={tab.key}
                        type="button"
                        className={activeTab === tab.key ? 'active' : ''}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </TabBar>

            <TabContent>
                {activeTab === 'lists' && (
                    <MasterListsTab
                        companyId={companyId}
                        onNewListClickRef={newListHandlerRef}
                    />
                )}
                {activeTab === 'editor' && (
                    <TemplateEditorTab companyId={companyId} />
                )}
                {activeTab === 'migration' && (
                    <MigrationWizardTab companyId={companyId} />
                )}
            </TabContent>
        </PageWrap>
    )
}
